import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconAbstract({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} fill-rule="evenodd" d="M11.71.325c1.033.203 1.983.591 2.723 1.378.595.633.928 1.402 1.132 2.232.282 1.143.358 2.31.376 3.482.023 1.493-.017 2.98-.321 4.45-.44 2.126-1.688 3.36-3.82 3.808-1.253.263-2.519.323-3.792.325-1.42.002-2.836-.044-4.222-.398-1.494-.381-2.618-1.206-3.192-2.687-.307-.794-.444-1.622-.536-2.462-.04-.357-.074-.714-.111-1.071V6.598c.018-.113.045-.224.053-.337.062-.918.172-1.826.44-2.71C.896 2.043 1.84.995 3.365.555A11.93 11.93 0 0 1 5.602.121c2.04-.18 4.085-.194 6.108.204zm-5.063 5.94c-1.655-.028-3.035 1.318-3.07 2.993-.034 1.707 1.296 3.083 3.02 3.125 1.669.042 3.062-1.32 3.097-3.025.034-1.69-1.321-3.065-3.047-3.094zm5.52-2.49H3.729v1.5h6.99v6.976h1.448V3.775zM6.616 7.756a1.565 1.565 0 0 1 1.576 1.568c.01.845-.7 1.556-1.555 1.557a1.553 1.553 0 0 1-1.558-1.522c-.009-.886.672-1.596 1.537-1.603z"/>
        </svg>
    );
}

export default IconAbstract;
